import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import GlobalPostbackPresetsSelect from './GlobalPostbackPresetsSelect';
import CustomControl from '../../../../components/CustomControl/CustomControl';
import { FormGroup, Col } from 'reactstrap'


export default ({ onPresetApply }) => {
    const [checked, toggleCheck] = useState(false);

    return (
        <FormGroup className='presets'>
            <Col lg='4'>
                <CustomControl
                    id={`presets-check`}
                    label={<FormattedMessage
                        id="postback.global.presets.title"
                        defaultMessage="postback.global.presets.title"
                    />}
                    className="preset-check custom-control-xs"
                    type='checkbox'
                    value={checked}
                    checked={checked}
                    onChange={() => toggleCheck(!checked)}
                />
            </Col>
            <Col lg='8'>
                <GlobalPostbackPresetsSelect checked={checked} onPresetApply={onPresetApply} />
            </Col>
        </FormGroup>
    )
}